/**
 * Coordonnées géographiques approximatives du centre de chaque département français
 * Format: [latitude, longitude]
 * 
 * Ces coordonnées servent à positionner les marqueurs des utilisateurs du top 10
 * au niveau départemental.
 */

export const DEPARTMENT_COORDINATES = {
    // Auvergne-Rhône-Alpes
    '01': [46.2044, 5.2255],    // Ain
    '03': [46.5670, 3.3333],    // Allier
    '07': [44.7357, 4.5996],    // Ardèche
    '15': [45.0379, 2.6004],    // Cantal
    '26': [44.7333, 5.0000],    // Drôme
    '38': [45.1667, 5.7167],    // Isère
    '42': [45.4397, 4.3872],    // Loire
    '43': [45.0439, 3.8850],    // Haute-Loire
    '63': [45.7772, 3.0870],    // Puy-de-Dôme
    '69': [45.7640, 4.8357],    // Rhône
    '73': [45.5646, 6.3250],    // Savoie
    '74': [46.0000, 6.3500],    // Haute-Savoie

    // Bourgogne-Franche-Comté
    '21': [47.3220, 4.8667],    // Côte-d'Or
    '25': [47.2380, 6.0240],    // Doubs
    '39': [46.6734, 5.5544],    // Jura
    '58': [47.1126, 3.5285],    // Nièvre
    '70': [47.6283, 6.1566],    // Haute-Saône
    '71': [46.6541, 4.5553],    // Saône-et-Loire
    '89': [47.8667, 3.5667],    // Yonne
    '90': [47.6333, 6.8667],    // Territoire de Belfort

    // Bretagne
    '22': [48.4500, -2.8333],   // Côtes-d'Armor
    '29': [48.2333, -4.0667],   // Finistère
    '35': [48.1173, -1.6778],   // Ille-et-Vilaine
    '56': [47.7500, -2.7500],   // Morbihan

    // Centre-Val de Loire
    '18': [47.0833, 2.3981],    // Cher
    '28': [48.4469, 1.4892],    // Eure-et-Loir
    '36': [46.8108, 1.6909],    // Indre
    '37': [47.3939, 0.6894],    // Indre-et-Loire
    '41': [47.5858, 1.3359],    // Loir-et-Cher
    '45': [47.9028, 2.0833],    // Loiret

    // Corse
    '2A': [41.9267, 8.7369],    // Corse-du-Sud
    '2B': [42.5500, 9.2500],    // Haute-Corse

    // Grand Est
    '08': [49.7619, 4.7200],    // Ardennes
    '10': [48.2972, 4.0789],    // Aube
    '51': [49.0472, 4.3658],    // Marne
    '52': [48.1133, 5.1414],    // Haute-Marne
    '54': [48.6847, 6.1844],    // Meurthe-et-Moselle
    '55': [49.0069, 5.3708],    // Meuse
    '57': [49.1197, 6.1778],    // Moselle
    '67': [48.5734, 7.7521],    // Bas-Rhin
    '68': [47.7470, 7.3389],    // Haut-Rhin
    '88': [48.1736, 6.4514],    // Vosges

    // Hauts-de-France
    '02': [49.5637, 3.6275],    // Aisne
    '59': [50.6292, 3.0573],    // Nord
    '60': [49.4173, 2.8261],    // Oise
    '62': [50.5208, 2.6347],    // Pas-de-Calais
    '80': [49.8947, 2.2958],    // Somme

    // Île-de-France
    '75': [48.8566, 2.3522],    // Paris
    '77': [48.6047, 2.9989],    // Seine-et-Marne
    '78': [48.8050, 1.9936],    // Yvelines
    '91': [48.5319, 2.2408],    // Essonne
    '92': [48.8500, 2.2500],    // Hauts-de-Seine
    '93': [48.9095, 2.5281],    // Seine-Saint-Denis
    '94': [48.7767, 2.4875],    // Val-de-Marne
    '95': [49.0500, 2.1000],    // Val-d'Oise

    // Normandie
    '14': [49.1829, -0.3707],   // Calvados
    '27': [49.0258, 0.8900],    // Eure
    '50': [49.1167, -1.0833],   // Manche
    '61': [48.4333, 0.0833],    // Orne
    '76': [49.5428, 1.0333],    // Seine-Maritime

    // Nouvelle-Aquitaine
    '16': [45.6500, 0.1500],    // Charente
    '17': [45.7481, -0.6342],   // Charente-Maritime
    '19': [45.2667, 1.7667],    // Corrèze
    '23': [46.1708, 1.8667],    // Creuse
    '24': [45.1500, 0.7167],    // Dordogne
    '33': [44.8378, -0.5792],   // Gironde
    '40': [43.8944, -0.5000],   // Landes
    '47': [44.2028, 0.6200],    // Lot-et-Garonne
    '64': [43.3000, -0.5000],   // Pyrénées-Atlantiques
    '79': [46.3239, -0.4642],   // Deux-Sèvres
    '86': [46.5802, 0.3404],    // Vienne
    '87': [45.8354, 1.2644],    // Haute-Vienne

    // Occitanie
    '09': [42.9667, 1.6000],    // Ariège
    '11': [43.2167, 2.3500],    // Aude
    '12': [44.3522, 2.5750],    // Aveyron
    '30': [43.8378, 4.3601],    // Gard
    '31': [43.6047, 1.4442],    // Haute-Garonne
    '32': [43.6481, 0.5856],    // Gers
    '34': [43.6108, 3.8767],    // Hérault
    '46': [44.4478, 1.4411],    // Lot
    '48': [44.5181, 3.5000],    // Lozère
    '65': [43.2333, 0.0833],    // Hautes-Pyrénées
    '66': [42.6886, 2.8948],    // Pyrénées-Orientales
    '81': [43.9289, 2.1481],    // Tarn
    '82': [44.0172, 1.3553],    // Tarn-et-Garonne

    // Pays de la Loire
    '44': [47.2184, -1.5536],   // Loire-Atlantique
    '49': [47.4739, -0.5522],   // Maine-et-Loire
    '53': [48.0694, -0.7703],   // Mayenne
    '72': [48.0061, 0.1996],    // Sarthe
    '85': [46.6708, -1.4264],   // Vendée

    // Provence-Alpes-Côte d'Azur
    '04': [44.0939, 6.2364],    // Alpes-de-Haute-Provence
    '05': [44.6619, 6.0789],    // Hautes-Alpes
    '06': [43.9408, 7.1214],    // Alpes-Maritimes
    '13': [43.5297, 5.4474],    // Bouches-du-Rhône
    '83': [43.4667, 6.2333],    // Var
    '84': [43.9492, 5.0528],    // Vaucluse

    // DOM-TOM (codes spéciaux)
    '971': [16.2650, -61.5510], // Guadeloupe
    '972': [14.6415, -61.0242], // Martinique
    '973': [4.9228, -52.3260],  // Guyane
    '974': [-21.1151, 55.5364], // La Réunion
    '976': [-12.8275, 45.1660], // Mayotte
};

/**
 * Récupère les coordonnées d'un département à partir de son code
 * @param {string} departmentCode - Code du département (ex: '75', '2A', '971')
 * @returns {[number, number]|null} Coordonnées [lat, lng] ou null si non trouvé
 */
export function getDepartmentCoordinates(departmentCode) {
    if (!departmentCode) return null;
    return DEPARTMENT_COORDINATES[departmentCode] || null;
}

/**
 * Vérifie si un département a des coordonnées disponibles
 * @param {string} departmentCode - Code du département
 * @returns {boolean}
 */
export function hasDepartmentCoordinates(departmentCode) {
    return departmentCode && !!DEPARTMENT_COORDINATES[departmentCode];
}
